export class ImplementsBreifViewModel {
  public ImplementId: number;
  public ImplmentTypeId: number;
  public ImplementSerialNumber: string;
  public ImplementsImage: string;
  public HowManyComponents: number;
  public DateInstalled: Date;
  public EquipmentSmuAtInstall: Date;
  public AvailableShematics: SchematicsViewModel[];
}



export class SchematicsViewModel {
  public Id: number;
  public Image: string;
  public ButtonPositions: string;
  public FileName: string;

}

export class ComponentTypes {
  public componentId: number
  public componentTypeId: number
  public componentTypeName: string
  public Residual:number;
  public Life :number;
  public Worn :number;
  public CompTypeComment:string
  public ReportOptionId: number;
  public SchematicName: string
  public SchematicId: number;
  public SchematicPath: string
}

export class ReportOptionsVm {
  public Id: number
  public ComponentTypeId: number
  public ComponentTypeName: string
  public IncludeGraph: boolean
  public IncludeDataTable: boolean
  public IncludeSummary: boolean
  public AlterGroupName: string
  public Comment: string
  public Eval: number
  public group_order: number;
  public ChartType: number
  public IncludeInBody: boolean;
  public RepairComment:string;
  public GeneralComment:string;
  public None:boolean;
  public Stage1:boolean
  public Stage2:boolean
  public Stage3:boolean
  public Stage4:boolean
  //added by Hans Raj Sharma as on 17 Jan 2023 TT-6788
  public IncludeSchematicInSummary:boolean;
  //---
  public ImageRotationId:number;
  public ShowImageRotation:boolean;
}
export class WearStatusPackages{
  public InspectionId:number;
  public WearNoe:boolean;
  public Wear_1:boolean;
  public Wear_2:boolean;
  public Wear_3:boolean;
  public Wear_4:boolean;

}

export class PreInspectionChecklistVM {
  public InspectionId: number;
  public QuestionId: number;
  public Question: string;
  public ChecklistAnswerId: number;
  public Comment: string;
  public Answer: number;
  public Images: CheckListImagesVM[] = [];
}

export class CheckListImagesVM {
  public Id: number;
  public Image: string;
  public AnswerId: number;
}
export class ComponentTypeImagesVM {
  public Id: number;
  public Image: string;
  public compart_attach_auto: string;
}
export class InspectedImplementsViewModel {
  public ImplementId: number;
  public ImplementTypeId: number;
  public EquipmentId: number;

  public ImplementInspectionId: number;

  public ImplementSerialNumber: string;
  public ImplementsImage: string;

  public Inspector: string;
  public OverallComment: string;
  public MeterReading: number;

  public IncludeOnReport: boolean;
  public DateInstalled: Date;
  public EquipmentSmuAtInspection: number;
  public EquipmentSmuAtInstall: number;

  public InspectionDate: Date;
  public InspectionStringDate: string;

  public InspectionImages: ImplementInspectionImageViewModel[];
  public GeneralQuestions: InspectImplementQuestionViewModel[];
  public Components: InspectedComponentsOnImplementViewModel[];
  public AvailableShematics: AvailableShematics[];
  public IncludeOverallComment: boolean;
  public ComponentTypes: ComponentTypes[];
  public ComponentTypeIds: number[];
  public GETTypeId:number;
  public GETType:string;

  public CompTypeSummary:string;
  public Recommendation:string;
  public WorkRequired:string;

  public WorkOrder:string;
  public JobFileNo:string;
  public RepairRequestNo:string

}


export class InspectImplementQuestionViewModel {
  public Id: number;
  public Description: string;
  public Image: GeneralQuestionImageViewModel[];
  public PossibleAnswers: InspectImplementAnswersViewModel[];
  public Answer: InspectImplementAnswersViewModel;
  public IsAnswerOptional: boolean;
}

export class GeneralQuestionImageViewModel {
  public ImageId: number;
  public ImageData: string;
  public ImageComment: string;
  public ImageTitle: string;
  public InspectionGeneralQuestionId: number;
  public ImplementInspectionId: number;
  /**
   *
   */
  constructor(image: string) {
    this.ImageData = image;
  }
}


export class InspectionOverallCommentUpdateCommentViewModel {
  public ImplementInspectionId: number;
  public CommentContent: string;
  public WorkRequired: string;
  public Recommendation: string;
}

export class ComponentReprtGroupUpdateModel {
  public componentInspectionId: number;
  public ChangeReportingGroup: number;
}

export class ReportOptionValue {
  public Id: number
  public selectedValue: number;
  public AlterGroupName: string;
  public Comment: string;
}

export class NewImageForGeneralQuestionsOnInspectionModel {
  public ImageId: number;
  public ImplementInspectionId: number;
  public InspectionGeneralQuestionId: number;
  public ImageData: string;
}

export class InspectImplementAnswersViewModel {
  public Id: number;
  public ResultDescription: string;
  public DisplayOrder: number;
  public RelatedQuestionId: number;
}
export class PreCheckListAnswerUpdate {
  public AnswerId: number;
  public NewAnswer: boolean;
}



export class InspectedComponentsOnImplementViewModel {
  public ComponentInspectionId: number;
  public ComponentId: number;
  public ComponentName: string;
  public PartNumber: string;
  public MakeId: number;
  public SortOrder: number;
  public Flag: boolean;
  public Cmu: number;
  public ViewObservationPointsIds: number[];
  public ObservationPoints: InspectionObservationPointsViewModel[];
  public ComponentType: string;
  public ReportGrouping: number;
  public ObservationPointsFiltered: InspectionObservationPointsViewModel[];
  public ComponentTypeId: number;
  public isCritical: boolean;
  public Residual :number;
  public CNG:string;

}


export class InspectionObservationPointsViewModel {
  public Id: number;
  public ObservationPointId: number;
  public ObservationName: string;
  public ObservationTypeId: number;
  public ObservationTypeName: string;
  public LimitNew: number;
  public LimitScrap: number;
  public LimitRange: number;
  public WornPercentage: number;
  public MaxReadings: number;
  public ComponentId: number;
  public Comments: string;
  public Image: string;
  public ImagePath: string;
  public QuestionInstruction: string;
  public QuestionTitle: string;
  public InspectionImages: ImplementInspectionImageViewModel[];
  public SchematicId: number;
  public ObservationImages: ObservationImagesViewModel[];
  public ObservationMeasurements: ObservationMeasurementViewModel[];
  public ObservationListQuestions: ObservationQuestionListViewModel[];
  public ComponentName: string;
  public PartNumber: string;
  public SortOrder: number;
  public Flag: boolean;
  public Cmu: number;
  public ComponentType: string;
  public ComponentTypeId: number;
  public isCritical: boolean;
  public CompWorstWorn: number;
  public Reading:number;
  public obsSeverityList:OBSseveityList[]
  public ObsList:OBSseveityList[]
  public severityID: number;
  public severityIDs: number[];
  public CNG: string;
  public PositionX: number;
  public PositionY: number;
  public EndPositionX: number;
  public EndPositionY: number;
  public obsId: number;
  public CrackLocationId: number;
  public isImage: boolean;
  public isAnswer: boolean;
  public LocationName: string;
  public CrackStatusId?: number;
}

export class OBSseveityList {
  public  ID:number;
  public  Name:string;
  public CrackObsList: number;
  public CrackSeverityList: number;
}


export class ImplementInspectionImageViewModel {
  public ImageId: number;
  public ImageData: string;
  public ImageDataPath: string;
  constructor(image: string) {
    this.ImageData = image;
  }
}

export class ObservationListRental{
  public InspectionObservationPoints_: InspectionObservationPointsViewModel;
}




export class ObservationImagesViewModel {
  public Id: number;
  public ImageData: string;
  public ImageDataPath: string;
  /**
   *
   */
  //constructor(image: string) {
  //  this.ImageData = image;
  //}
  constructor();
  constructor(image: string);
  constructor(image: string, imagePath: string);
  constructor(id: number, image: string, imagePath: string);
  constructor(idOrImage?: number | string, imageOrPath?: string, imagePath?: string) {
    if (typeof idOrImage === 'number') {
      this.Id = idOrImage;
      this.ImageData = imageOrPath;
      this.ImageDataPath = imagePath;
    } else if (typeof idOrImage === 'string' && typeof imageOrPath === 'string') {
      this.ImageData = idOrImage;
      this.ImageDataPath = imageOrPath;
    } else if (typeof idOrImage === 'string') {
      this.ImageData = idOrImage;
    }
  }
}

export interface ObservationMeasurementViewModel {
   Id: number;
   MeasurementReading: number;
   ReadingPosition: number;
}

export class ObservationQuestionListViewModel {
  public ObservationPointId: number;
  public QuestionListId: number;
  public ListDesc: string;
  public Questions: ObservationQuestionsViewModel[];
}

export class ObservationQuestionsViewModel {
  public Id: number;
  public QuestionDesc: string;
  public Checked: boolean;
  public Images: ObservationPointQuestionImagesViewModel[];
}

export class ObservationPointQuestionImagesViewModel {
  public ImageId: number;
  public Image: string;

  /**
   *
   */
  constructor(image: string) {
    this.Image = image;
  }
}

export class AvailableShematics {
  public Id: number;
  public Image: string;
  public ButtonPositions: string;
  public FileName: string;
}



export enum PhotoModelComingFrom {
  NewInspectionQuestionImages = 3,
  InterpretationQuestionImages = 4,
  NewInspectionInspectionImages = 5,
  InterpretationInspectionImages = 6,
  PreCheckListQuestionImages = 12,
  NewInspectionGeneralQuestionsImagesOnImplementLevel = 7,
  InterpretationGeneralQuestionsImagesOnImplementLevel = 8,
  NewInspectionObservationPointImageOnComponentLevel = 9,
  InterpretationObservationPointImageOnComponentLevel = 10,
  EquipmentDetails = 11,
  FECRAdditionalObs = 13,
  DisplayComponentImageType =14,
  ImplementImage = 15,
  BogieInspectionImage = 16,
  BogieInspectionImageHistory= 17,
  BogieNewInspectionImage = 18,
  BogieInterpImage = 19,
  BogieImageEquipmentPage = 20,
  AuditTrail = 21,
}

export enum CommentModelComingFrom {
  NewInspection = 1,
  Interpretation = 2,
  PreChecklist = 3,
}

export enum QuestionModelComingFrom {
  NewInspection = 1,
  Interpretation = 2,
}


export class ObservationPhotosViewModel {
  public Id: number;
  public Image: string;
  public ObservationPoint: number;
}




export class UpdatePreCheckListCommentViewModel {
  public AnswerId: number;
  public Comment: string;
}

export class UpdateObservationCommentViewModel {
  public ObservationPointInspectionId: number;
  public Comment: string;
}

export class UpdateInspectionImagePhotoViewModel {
  public ImageId: number;
  public ImageData: string;
}
export class UpdateComponentImageViewModel {
  public ImageId: number;
  public ImageData: string;
  public compart_attach_auto: Number;
  public ImageName: string;
  public tool_auto: string;
  public comparttype_auto: string;


}

export class UpdatePreInspectionImagePhotoViewModel {
  public ImageId: number;
  public ImageData: string;
  public AnswerId: number
}

export class UpdateIncludeReportObservation {
  public ComInspectionId: number;
  public Value: boolean;
}

export class NewImageForImplementInspectionViewModel {
  public ImageData: string;
  public ImplementInspectionId: number;
}


export class InspectionRequestModel {
  public EquipmentId: number;
  public Date: string;
  public StringDate: string;
  constructor(equipmentId: number, date: string) {
    this.EquipmentId = equipmentId;
    this.Date = date;
    this.StringDate = date;
  }
  
}




export class UploadNewImagesToObservationPointModel {
  public ObservationPointInspectionId: number;
  public ImageData: string;
}



export class UpdateImplementLevelEquipmentAnswersModel {
  public ImplementInspectionId: number;
  public Question: InspectImplementQuestionViewModel;
  public SelectedAnswer: InspectImplementAnswersViewModel;

}





export class AddNewMeasurementToObservationPointModel {
  public ObservationPointInspectionId: number;
  public ReadingPosition: number;
  public ReadingValue: number;
}

export class AssetDetail{
  public AssetTypeId: number;
  public AssetName: string;
  public ImplementAuto: number;
  public ImplementDescription: string;
  public AssetSerial: string;
  public GETAuto: number;
}

export class WorkOrderUpdate {
  public ImplementInspectionId: number;
  public WorkOrder: string;
}

export class InspectionCompTypeCompObsPoints {
  ComponentId: number;
  ComponentTypeId: number;
  ComponentTypeName: string;
  CompTypeResidual: number;
  CompTypeLife: number;
  CompTypeWorn: number;
  CompTypeComment: string;
  ReportOptionId: number;

  GETComponentTypeId?: number;
  GETTypeId?: number;

  SchematicOrder: number;
  ComponentOrder: number;
  SchematicName: string;
  SchematicPath: string;

  Id: number;
  ObservationPointId: number;
  ObservationTypeId: number;
  ObservationTypeName: string;

  LimitNew: number;
  LimitScrap: number;
  LimitRange: number;
  WornPercentage: number;
  MaxReadings: number;

  ObservationMeasurements: ObservationMeasurementViewModel[]=[];
  ObservationMeasurementsJson: string;

  Comments: string;
  Image: number[];
  ImagePath: string;
  QuestionInstruction: string;
  QuestionTitle: string;
  ObservationName: string;

  IncludeReport: boolean;

  ObservationImages: ObservationImagesViewModel[] = [];
  ObservationImagesJson: string;
  ObservationListQuestions: ObservationQuestionListViewModel[]=[];

  SchematicId: number;
  ComponentName: string;
  PartNumber: string;
  MakeId: number;
  SortOrder: number;
  Cmu: number;

  Flag: boolean;
  ComponentType: string;

  ReportGrouping?: number;
  isCritical: boolean;

  CompWorstWorn: number;
  IsCrackFixed: boolean;

  Residual: number;
  Reading: number;

  obsSeverityList: OBSseveityList[]=[];
  ObsSeverityJson: string;
  ObsList: OBSseveityList[]=[];
  ObsListJson: string;
  obsId: number;

  severityID?: number;
  severityIDs: (number | null)[]=[];
  SeverityIDsJson: string;

  CNG: string;

  PositionX: number;
  PositionY: number;
  EndPositionX?: number;
  EndPositionY?: number;

  CrackLocationId?: number;

  isImage: boolean;
  isAnswer: boolean;
  LocationName: string;
  CrackStatus?: string;
  CrackStatusId?: number;
}


